import {
  DELETE_CMS_LANGUAGE_FAILURE,
  DELETE_CMS_LANGUAGE_REQUEST,
  DELETE_CMS_LANGUAGE_SUCCESS,
  FETCH_CMS_LANGUAGES_FAILURE,
  FETCH_CMS_LANGUAGES_REQUEST,
  FETCH_CMS_LANGUAGES_SUCCESS,
  SAVE_CMS_LANGUAGE_FAILURE,
  SAVE_CMS_LANGUAGE_REQUEST,
  SAVE_CMS_LANGUAGE_SUCCESS,
} from '../../reducers/types';
import { getCmsLanguagesService } from '../../services/appCmsServices/CmsLanguageService';
import {
  saveLanguageService,
  deleteLanguagesService,
} from '../../services/specServices/LanguageService';

export const getCmsLanguagesAction = (value = '') => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_CMS_LANGUAGES_REQUEST,
      });
      const response = await dispatch(getCmsLanguagesService(value));
      if (response.status === 200) {
        dispatch({
          type: FETCH_CMS_LANGUAGES_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_CMS_LANGUAGES_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_CMS_LANGUAGES_FAILURE,
      });
    }
  };
};

export const saveCmsLanguageAction = (data, id = 0) => {
  return async dispatch => {
    try {
      dispatch({
        type: SAVE_CMS_LANGUAGE_REQUEST,
      });
      const response = await dispatch(saveLanguageService(data, id));
      if (response.status === 200) {
        dispatch({
          type: SAVE_CMS_LANGUAGE_SUCCESS,
          payload: response.data,
        });
        dispatch(getCmsLanguagesAction());
      } else {
        dispatch({
          type: SAVE_CMS_LANGUAGE_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: SAVE_CMS_LANGUAGE_FAILURE,
      });
    }
  };
};

export const deleteCmsLanguageAction = array => {
  return async dispatch => {
    try {
      dispatch({
        type: DELETE_CMS_LANGUAGE_REQUEST,
      });

      const response = await dispatch(deleteLanguagesService(array));
      if (response.status === 200) {
        dispatch({
          type: DELETE_CMS_LANGUAGE_SUCCESS,
        });
        dispatch(getCmsLanguagesAction());
      } else {
        dispatch({
          type: DELETE_CMS_LANGUAGE_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: DELETE_CMS_LANGUAGE_FAILURE,
      });
    }
  };
};
